import { ConfigProvider, Skeleton } from 'antd';

const InventoryGroupFormSkeleton = () => {
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Skeleton: {
              paragraphLiHeight: 20,
            },
          },
        }}
      >
        <div className="tw-relative md:tw-h-32">
          <div className="tw-flex tw-flex-col tw-gap-6">
            <Skeleton
              active
              title={{ width: '100px' }}
              paragraph={{ rows: 1, width: '350px' }}
            />
          </div>
          <div className="tw-absolute tw-bottom-0 tw-right-2">
            <div className="tw-flex tw-gap-4">
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: '70px' }}
              />
              <Skeleton
                active
                title={false}
                paragraph={{ rows: 1, width: '70px' }}
              />
            </div>
          </div>
        </div>
      </ConfigProvider>
    </>
  );
};

export default InventoryGroupFormSkeleton;
